/* eslint-disable radix */
/* eslint-disable max-len */
/* eslint-disable no-console */
/* eslint-disable func-names */
import React, { useState, useEffect, createContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, MenuItem, FormControl, Select, Button } from '@mui/material';
import { isEmpty } from 'lodash';
import { systemUnitsIconColor } from '../../shared/assets/images/index';
import { roMachine } from '../../shared/api/url-helper';
import { decrypt_data } from '../../shared/utils';
import { convertUnitValues_flow } from '../../shared/conversion-helper/unitConversion';

import './roMachine.scss';
import RomCard from './RomCard';

import { defaultModalOptions, defaultUnitValues } from '../../shared/constantVariable';
import Notification from '../../shared/notification-modal';
import SystemUnits from '../system-units';
import { removeItemFromLocalStorage } from '../../shared/removeElements';

export const ExecuteContext = createContext();

const RoMachine = () => {
  const { t } = useTranslation();
  const translateObject = t;
  const [units, setUnits] = useState(defaultUnitValues);
  const [visibleUnits, setVisibleUnits] = useState(false);
  const executeEDIInfoData = useMemo(() => ({ data: {}, reportData: {} }), []);

  const [modalOption, setModalOption] = useState(defaultModalOptions);
  const [messageTxt, setMessageTxt] = useState('Choose any RO-EDI Equipment Model to Display the Data');
  const [copyData, setCopyData] = useState([]);
  const [perMuteFlowRate, setPerMuteFlowRate] = useState('');
  // Multi Ro machine
  const [roMachineModel, setRoMachineModel] = useState([]);
  // Dropdown item
  const [roMachineDdItem, setRoMachineDdItem] = useState([]);
  // Units
  const SessionExpTime = sessionStorage.getItem('expTime');
  let currTime = new Date().getTime().toString();
  currTime = currTime.substring(0, 10); // 1653312386

  if (parseInt(currTime) >= parseInt(SessionExpTime)) {
    removeItemFromLocalStorage();
    if (localStorage.getItem('db_version')) {
      localStorage.removeItem('db_version');
    }
    window.location.href = '/sign-in';
  };
  const handleCloseOption = () => {
    setVisibleUnits(false);
  };
  // RO-Machine-Model Dropdown
  const [roModel, setRoModel] = useState('');

  const onDropdownChange = (ev) => {
    setPerMuteFlowRate('');
    if (!(ev.target.value === 'No options')) {
      setRoModel(ev.target.value);
      setCopyData([roMachineModel[ev.target.value]]);
    }
  };

  const onlyPositiveNum = (num) => {
    const posiNum = num <= 0 ? '' : Number(num); // change the condition for GB-2378 issue by kranthi
    setPerMuteFlowRate(posiNum);
  };

  function inBetween(a, b) {
    return function (x) {
      x = x.ApproxPermeateflow;
      return x >= a && x <= b;
    };
  };

  const handleonOK = () => {
    if (Number(perMuteFlowRate) === 0) {
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        title: 'Warning',
        message: translateObject('Permeate Flow Rate must not be empty'),
        yesOrNo: false,
        onNo: () => setModalOption(defaultModalOptions)
      });
    }
    else { // eslint-disable-next-line
      setRoModel('');
      if (units.flow === 'gpm') {
        let perct = Math.floor(perMuteFlowRate * 0.2);
        if (perMuteFlowRate < 5) {
          perct = perMuteFlowRate * 0.2;
        }
        const minVal = Math.floor(perMuteFlowRate - perct);
        const maxVal = Math.ceil(perMuteFlowRate + perct);
        const filteredROmModel = Object.values(roMachineModel).filter(inBetween(minVal, maxVal));
        setCopyData(filteredROmModel);
        if (filteredROmModel.length === 0) {
          setMessageTxt('No Result Found!');
        }
      } else {
        // unit m3/hr hai
        const convertedValueinGPM = convertUnitValues_flow(perMuteFlowRate, units.flow, 'gpm');
        const perct = Math.floor(convertedValueinGPM * 0.2);
        const minVal = Math.floor(convertedValueinGPM - perct);
        const maxVal = Math.ceil(convertedValueinGPM + perct);
        const filteredROmModel = Object.values(roMachineModel).filter(inBetween(minVal, maxVal));
        setCopyData(filteredROmModel);
        if (filteredROmModel.length === 0) {
          setMessageTxt('No Result Found!');
        }
      }
    };
  };
  useEffect(() => {
    roMachine().then((res) => {
      const decData = decrypt_data(res.data);
      const roMachine = Object.values(decData.romachine_dict);
      const filteredRoMach_dict = {};
      // filter data based in passkey is `0`
      let filteredRoMach = roMachine.filter(item => item.PassCode === 0);
      // sort data based on `ROID2`
      filteredRoMach = Object.values(filteredRoMach).sort((a, b) => {
        return a.ROID2 > b.ROID2 ? 1 : -1;
      });
      // create data key value pair
      filteredRoMach.map((ele) => {
        filteredRoMach_dict[ele.ROMachineModel] = ele;
      });
      // Set Dropdown Item
      setRoMachineDdItem(Object.keys(filteredRoMach_dict));
      // Set filter machine only
      setRoMachineModel(filteredRoMach_dict);
    }).catch(() => {
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        title: 'Warning',
        message: translateObject('Failed to fetch Ro Machine record'),
        yesOrNo: false,
        onNo: () => setModalOption(defaultModalOptions)
      });
    });
  }, []);
  useEffect(() => {
    if (!isEmpty(JSON.parse(localStorage.getItem('system-units')))) {
      const prevUnits = { ...units };
      setPerMuteFlowRate(parseFloat(convertUnitValues_flow(perMuteFlowRate, prevUnits.flow, JSON.parse(localStorage.getItem('system-units')).flow).toFixed(1)));
      setUnits(JSON.parse(localStorage.getItem('system-units')));
    }
  }, [visibleUnits]);
  useEffect(() => {
    if (!isEmpty(JSON.parse(localStorage.getItem('default_unit_set_dict')))) {
      const prevUnits = { ...units };
      setPerMuteFlowRate(parseFloat(convertUnitValues_flow(perMuteFlowRate, prevUnits.flow, JSON.parse(localStorage.getItem('default_unit_set_dict'))['Volume Flow']).toFixed(1)));
      setUnits({
        type: JSON.parse(localStorage.getItem('default_unit_set_dict')).type,
        temp: JSON.parse(localStorage.getItem('default_unit_set_dict')).Temperature,
        pressure: JSON.parse(localStorage.getItem('default_unit_set_dict')).Pressure,
        flow: JSON.parse(localStorage.getItem('default_unit_set_dict'))['Volume Flow'],
        flux: JSON.parse(localStorage.getItem('default_unit_set_dict')).Flux,
        power: JSON.parse(localStorage.getItem('default_unit_set_dict')).Power,
        volume: JSON.parse(localStorage.getItem('default_unit_set_dict'))['Liquid Volume'],
      });
    }
  }, []);
  return (
    <Grid container className='ROM_container'>
      <Grid item xs={12} className='Main_Heading L_heading'>{translateObject('RO-EDI Equipment Selector')}</Grid>
      <Grid container className='ROM_input_container'>
        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={3}>
              <Grid item xs={12} className='L_Regular'>{translateObject('Select Equipment Model')}</Grid>
              <Grid item xs={12} className='select-rom-dropdown'>
                <FormControl sx={{ m: 0, minWidth: '100%' }}>
                  <Select
                    id='ddItemSelect'
                    displayEmpty
                    sx={{
                      '.MuiOutlinedInput-notchedOutline': {
                        borderColor: '#B8B8CB',
                      },
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#55555A',
                      },
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#CCE4FF',
                      },
                    }}
                    inputProps={{ 'aria-label': 'Without label' }}
                    value={roModel}
                    name='romUnitDd'
                    onChange={onDropdownChange}
                    className='Defautl_Large_input'
                    data-testid='romunit'>
                    {roMachineDdItem.length === 0 ?
                      <MenuItem key='0' value='No options' className='ddItem'>{translateObject('No options')}</MenuItem> :
                      roMachineDdItem.map((item, ind) => (
                        <MenuItem key={ind} value={item} className='ddItem'>{item}</MenuItem>
                      ))
                    }
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
            <Grid item xs={1} className='ROM_Middle'>
              <div className='ROM_Line' />
              {translateObject('OR')}
              <div className='ROM_Line' />
            </Grid>
            <Grid item xs={7}>
              <Grid item xs={12} className='L_Regular'>{translateObject('Nominal Permeate Flow Rate')}
                <Button aria-label="units" className='icon_Button'
                  onClick={() => setVisibleUnits(true)}>
                  <img src={systemUnitsIconColor} className="img-top" alt='units_color' />
                </Button>
              </Grid>
              <Grid container className='ROM_input_flow'>
                <Grid item xs={5} md={4} className='perFlwRate'>
                  <input
                    type='number' id='safefactvol'
                    value={perMuteFlowRate} onFocus={e => e.target.select()}
                    onChange={(e) => onlyPositiveNum((e.target.value))}
                    className='Defautl_Large_input' placeholder="ex. 30.0" />
                </Grid>
                <div className='ROM_Units' item xs={1}>{units.flow}</div>
                <Grid item xs={3} md={4}>
                  <Button className='Primary_Default_Large_Button' variant='contained'
                    onClick={handleonOK}>{translateObject('Submit')}</Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container className='ROM_output_container'>
        <Grid item xs={12}>
          <div className='wrapper-sort'>
            {copyData.length === 0 ?
              <div id='whenNoData' className='L_heading'>{translateObject(messageTxt)}</div> :
              <div id='whenData'>
                {copyData.map((item, cID) =>
                  <RomCard
                    machineModelName={item.ROMachineModel}
                    ApproxPermeateflow={item.ApproxPermeateflow}
                    FactSheet1={item.FactsheetLink}
                    FactSheet2={item.FactsheetLink2}
                    FactSheet3={item.FactsheetLink3}
                    unit={units}
                    item={item}
                    PassCode={item.PassCode}
                    cID={cID}
                    translateObject={translateObject}

                  />
                )}
              </div>
            }
          </div>
        </Grid>
      </Grid>
      <Notification
        options={modalOption}
        handleClose={() => setModalOption(defaultModalOptions)}
      />
      {visibleUnits && (
        <ExecuteContext.Provider value={executeEDIInfoData}>
          <SystemUnits
            visibleUnits={visibleUnits}
            handleCloseUnits={handleCloseOption}
            visibleDefaultUnits
            translateObject={translateObject}
          />
        </ExecuteContext.Provider>
      )}
    </Grid>
  );
};
export default RoMachine;